const prefersReducedMotionQuery = window.matchMedia(
  "(prefers-reduced-motion: reduce)"
);

const initial = prefersReducedMotionQuery.matches;

prefersReducedMotionQuery.addEventListener("change", () => {
  // this is incredibly unlikely to happen at runtime,
  // so just refresh; it's not worth needing to pull this
  // from a hook to have components dynamically update
  if (prefersReducedMotionQuery.matches !== initial) {
    window.location.reload();
  }
});

export const animationDuration = initial ? 0 : 0.2;
export const shouldAnimate = !initial;
